/* Belle's Secrets — product page (gallery, variants, quantity, sticky ATC) */
(function () {
  function money(cents, format) {
    format = (format || '${{amount}}').replace(/<[^>]+>/g, '');
    function fmt(n, p, t, d) {
      p = p == null ? 2 : p; t = t == null ? ',' : t; d = d == null ? '.' : d;
      if (isNaN(n) || n == null) return '0';
      n = (n / 100).toFixed(p);
      var parts = n.split('.');
      return parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + t) + (parts[1] ? d + parts[1] : '');
    }
    var m = format.match(/\{\{\s*(\w+)\s*\}\}/), key = m ? m[1] : 'amount', val;
    switch (key) {
      case 'amount_no_decimals': val = fmt(cents, 0); break;
      case 'amount_with_comma_separator': val = fmt(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': val = fmt(cents, 0, '.', ','); break;
      default: val = fmt(cents, 2);
    }
    return format.replace(/\{\{\s*\w+\s*\}\}/, val);
  }

  function initPDP(root) {
    if (root.dataset.bsPdpReady) return;
    root.dataset.bsPdpReady = '1';
    var moneyFormat = root.getAttribute('data-money-format') || '${{amount}}';

    /* ----- variants data ----- */
    var variants = [];
    var dataEl = root.querySelector('[data-bs-variants]');
    try { variants = JSON.parse(dataEl.textContent); } catch (e) { variants = []; }

    var idInput = root.querySelector('[data-bs-variant-id]');
    var priceEl = root.querySelector('[data-bs-price]');
    var compareEl = root.querySelector('[data-bs-compare]');
    var saveEl = root.querySelector('[data-bs-save]');
    var atc = root.querySelector('[data-bs-atc]');
    var atcText = root.querySelector('[data-bs-atc-text]');
    var atcPrice = root.querySelector('[data-bs-atc-price]');
    var stickyPrice = root.querySelector('[data-bs-sticky-price]');
    var optionInputs = root.querySelectorAll('[data-bs-option]');

    function currentOptions() {
      var opts = [];
      optionInputs.forEach(function (input) {
        if (input.checked) opts[parseInt(input.getAttribute('data-bs-option'), 10) - 1] = input.value;
      });
      return opts;
    }
    function findVariant(opts) {
      return variants.find(function (v) {
        return v.options.every(function (o, i) { return o === opts[i]; });
      });
    }
    function updateVariant() {
      var opts = currentOptions();
      var v = findVariant(opts);
      // Single/default-variant products have no option selectors — use the only variant.
      if (!v && optionInputs.length === 0) v = variants[0];
      // update selected labels
      root.querySelectorAll('[data-bs-opt-selected]').forEach(function (el) {
        var pos = parseInt(el.getAttribute('data-bs-opt-selected'), 10);
        if (opts[pos - 1]) el.textContent = opts[pos - 1];
      });
      if (!v) {
        if (atc) { atc.disabled = true; }
        if (atcText) atcText.textContent = 'Unavailable';
        return;
      }
      if (idInput) idInput.value = v.id;
      if (priceEl) {
        priceEl.textContent = money(v.price, moneyFormat);
        priceEl.classList.toggle('is-sale', v.compare_at_price > v.price);
      }
      if (compareEl) {
        if (v.compare_at_price > v.price) { compareEl.textContent = money(v.compare_at_price, moneyFormat); compareEl.hidden = false; }
        else compareEl.hidden = true;
      }
      if (saveEl) {
        if (v.compare_at_price > v.price) {
          saveEl.textContent = 'Save ' + Math.round((v.compare_at_price - v.price) / v.compare_at_price * 100) + '%';
          saveEl.hidden = false;
        } else saveEl.hidden = true;
      }
      if (atc) {
        atc.disabled = !v.available;
        if (atcText) atcText.textContent = v.available ? (atc.getAttribute('data-label') || atcText.dataset.label || defaultLabel) : 'Sold out';
      }
      if (atcPrice) atcPrice.textContent = v.available ? '· ' + money(v.price, moneyFormat) : '';
      if (stickyPrice) stickyPrice.textContent = money(v.price, moneyFormat);
      // gallery jump to variant media
      if (v.featured_media && stage) {
        var slide = stage.querySelector('[data-media-id="' + v.featured_media.id + '"]');
        if (slide) scrollToSlide(slide);
      }
      // update URL param (no reload)
      if (history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        history.replaceState({}, '', url.toString());
      }
    }
    var defaultLabel = atcText ? atcText.textContent : 'Add to bag';
    optionInputs.forEach(function (input) { input.addEventListener('change', updateVariant); });

    /* ----- gallery ----- */
    var stage = root.querySelector('[data-bs-gallery-stage]');
    var thumbs = root.querySelectorAll('[data-bs-thumb]');
    var dots = root.querySelectorAll('[data-bs-dot]');
    function scrollToSlide(slide) {
      if (!stage) return;
      var idx = Array.prototype.indexOf.call(stage.children, slide);
      stage.scrollTo({ left: idx * stage.clientWidth, behavior: 'smooth' });
      setActive(idx);
    }
    function setActive(idx) {
      thumbs.forEach(function (t, i) { t.classList.toggle('is-active', i === idx); });
      dots.forEach(function (d, i) { d.classList.toggle('is-active', i === idx); if (i === idx) d.setAttribute('aria-current', 'true'); else d.removeAttribute('aria-current'); });
    }
    thumbs.forEach(function (t, i) { t.addEventListener('click', function () { if (stage) { stage.scrollTo({ left: i * stage.clientWidth, behavior: 'smooth' }); setActive(i); } }); });
    dots.forEach(function (d, i) { d.addEventListener('click', function () { if (stage) { stage.scrollTo({ left: i * stage.clientWidth, behavior: 'smooth' }); setActive(i); } }); });
    if (stage) {
      var st;
      stage.addEventListener('scroll', function () {
        window.clearTimeout(st);
        st = window.setTimeout(function () { setActive(Math.round(stage.scrollLeft / stage.clientWidth)); }, 60);
      }, { passive: true });
    }

    /* ----- quantity ----- */
    var qtyWrap = root.querySelector('[data-bs-qty]');
    if (qtyWrap) {
      var qtyInput = qtyWrap.querySelector('[data-bs-qty-input]');
      qtyWrap.querySelector('[data-bs-qty-minus]').addEventListener('click', function () { qtyInput.value = Math.max(1, (parseInt(qtyInput.value, 10) || 1) - 1); });
      qtyWrap.querySelector('[data-bs-qty-plus]').addEventListener('click', function () { qtyInput.value = (parseInt(qtyInput.value, 10) || 1) + 1; });
    }

    /* ----- sticky mobile ATC ----- */
    var sticky = root.querySelector('[data-bs-sticky-atc]');
    if (sticky && atc) {
      var stickyAdd = sticky.querySelector('[data-bs-sticky-add]');
      if (stickyAdd) stickyAdd.addEventListener('click', function () { if (!atc.disabled) atc.click(); });
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (en) { sticky.classList.toggle('is-visible', !en.isIntersecting && window.innerWidth < 900); });
        }, { rootMargin: '0px 0px -40% 0px' });
        io.observe(atc);
      }
    }

    updateVariant();
  }

  function boot() { document.querySelectorAll('[data-bs-pdp]').forEach(initPDP); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
